import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../api/index";
import axios from "axios";

const initialState = {
  loading: false,
  loadingMore: false,
  createLoading: false,
  error: false,
  data: [],
  singleOrder: {},
  editingOrder: {},
  years: [],
  orderCreated: false,
  csvImported: false,
};

const ordersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    resetOrderCreated(state, action) {
      state.orderCreated = false;
    },
    resetEditingOrder(state, action) {
      state.editingOrder = {};
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getAllOrders.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAllOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addMoreOrders.pending, (state) => {
        state.loadingMore = true;
      })
      .addCase(addMoreOrders.fulfilled, (state, action) => {
        state.loadingMore = false;
        state.data = {
          ...state.data,
          orders: [...state.data.orders, ...action.payload.orders],
          totalCount: action.payload.totalCount,
          page: action.payload.page,
        };
      })
      .addCase(addMoreOrders.rejected, (state, action) => {
        state.loadingMore = false;
        state.error = action.payload;
      })
      .addCase(getOrdersByRetailerCode.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOrdersByRetailerCode.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getOrdersByRetailerCode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addMoreOrdersByRetailerCode.pending, (state) => {
        state.loadingMore = true;
      })
      .addCase(addMoreOrdersByRetailerCode.fulfilled, (state, action) => {
        state.loadingMore = false;
        state.data = {
          ...state.data,
          orders: [...state.data.orders, ...action.payload.orders],
          totalCount: action.payload.totalCount,
          page: action.payload.page,
        };
      })
      .addCase(addMoreOrdersByRetailerCode.rejected, (state, action) => {
        state.loadingMore = false;
        state.error = action.payload;
      })
      .addCase(getOrdersByAgentCode.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOrdersByAgentCode.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getOrdersByAgentCode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addMoreOrdersByAgentCode.pending, (state) => {
        state.loadingMore = true;
      })
      .addCase(addMoreOrdersByAgentCode.fulfilled, (state, action) => {
        state.loadingMore = false;
        state.data = {
          ...state.data,
          orders: [...state.data.orders, ...action.payload.orders],
          totalCount: action.payload.totalCount,
          page: action.payload.page,
        };
      })
      .addCase(addMoreOrdersByAgentCode.rejected, (state, action) => {
        state.loadingMore = false;
        state.error = action.payload;
      })
      .addCase(getOrderById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOrderById.fulfilled, (state, action) => {
        state.loading = false;
        state.singleOrder = action.payload;
      })
      .addCase(getOrderById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getEditingOrderById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getEditingOrderById.fulfilled, (state, action) => {
        state.loading = false;
        state.editingOrder = action.payload;
      })
      .addCase(getEditingOrderById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateOrderById.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateOrderById.fulfilled, (state, action) => {
        state.loading = false;
        state.orderCreated = true;
        state.data = {
          ...state.data,
          orders: state.data.orders?.map((order) => {
            if (order.internalCode === action.payload.internalCode) {
              return action.payload;
            }
            return order;
          }),
        };
      })
      .addCase(updateOrderById.rejected, (state, action) => {
        state.loading = false;
        state.orderCreated = false;
        state.error = action.payload;
      })
      .addCase(deleteOrderById.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteOrderById.fulfilled, (state, action) => {
        state.loading = false;
        // filter out the deleted order
        state.data = {
          orders: state.data.orders.filter(
            (order) => order.internalCode != action.payload
          ),
          totalCount: state.data.totalCount - 1,
          page: state.data.page,
        };
      })
      .addCase(deleteOrderById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(duplicateOrderById.pending, (state) => {
        state.loading = true;
      })
      .addCase(duplicateOrderById.fulfilled, (state, action) => {
        state.loading = false;
        // add the duplicated order to the list
        state.data = {
          ...state.data,
          orders: [action.payload, ...state.data.orders],
          totalCount: state.data.totalCount + 1,
        };
      })
      .addCase(duplicateOrderById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getOrderYears.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOrderYears.fulfilled, (state, action) => {
        state.loading = false;
        state.years = action.payload;
      })
      .addCase(getOrderYears.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.years = [];
      })
      .addCase(createNewOrder.pending, (state) => {
        state.createLoading = true;
      })
      .addCase(createNewOrder.fulfilled, (state) => {
        state.createLoading = false;
        state.orderCreated = true;
      })
      .addCase(createNewOrder.rejected, (state, action) => {
        state.createLoading = false;
        state.orderCreated = false;
        state.error = action.payload;
      });
  },
});

export const getAllOrders = createAsyncThunk(
  "ordersSlice/getAllOrders",
  async ({ currentPage, pageSize, q, orderStatus, typeStatus, date }) => {
    try {
      const { url, method, headers } = api.getAllOrders(
        currentPage,
        pageSize,
        q,
        orderStatus,
        typeStatus,
        date
      );
      const orders = await axios({
        url,
        method,
        headers,
      });
      return orders.data;
    } catch (error) {
      return error.message;
    }
  }
);

export const getOrdersByRetailerCode = createAsyncThunk(
  "ordersSlice/getOrdersByRetailerCode",
  async ({
    retailerCode,
    currentPage,
    pageSize,
    q,
    orderStatus,
    typeStatus,
    date,
  }) => {
    try {
      const { url, method, headers } = api.getOrdersByRetailerCode(
        retailerCode,
        currentPage,
        pageSize,
        q,
        orderStatus,
        typeStatus,
        date
      );

      const orders = await axios({
        url,
        method,
        headers,
      });
      return orders.data;
    } catch (error) {
      return error.message;
    }
  }
);

export const getOrdersByAgentCode = createAsyncThunk(
  "ordersSlice/getOrdersByAgentCode",
  async ({
    agentCode,
    currentPage,
    pageSize,
    q,
    orderStatus,
    typeStatus,
    date,
  }) => {
    try {
      const { url, method, headers } = api.getOrdersByAgentCode(
        agentCode,
        currentPage,
        pageSize,
        q,
        orderStatus,
        typeStatus,
        date
      );

      const orders = await axios({
        url,
        method,
        headers,
      });
      return orders.data;
    } catch (error) {
      return error.message;
    }
  }
);

export const addMoreOrders = createAsyncThunk(
  "ordersSlice/addMoreOrders",
  async ({ currentPage, pageSize, q, orderStatus, typeStatus, date }) => {
    try {
      const { url, method, headers } = api.getAllOrders(
        currentPage,
        pageSize,
        q,
        orderStatus,
        typeStatus,
        date
      );
      const orders = await axios({
        url,
        method,
        headers,
      });
      return orders.data;
    } catch (error) {
      return error.message;
    }
  }
);

export const addMoreOrdersByRetailerCode = createAsyncThunk(
  "ordersSlice/addMoreOrdersByRetailerCode",
  async ({
    retailerCode,
    currentPage,
    pageSize,
    q,
    orderStatus,
    typeStatus,
    date,
  }) => {
    try {
      const { url, method, headers } = api.getOrdersByRetailerCode(
        retailerCode,
        currentPage,
        pageSize,
        q,
        orderStatus,
        typeStatus,
        date
      );

      const orders = await axios({
        url,
        method,
        headers,
      });
      return orders.data;
    } catch (error) {
      return error.message;
    }
  }
);

export const addMoreOrdersByAgentCode = createAsyncThunk(
  "ordersSlice/addMoreOrdersByAgentCode",
  async ({
    agentCode,
    currentPage,
    pageSize,
    q,
    orderStatus,
    typeStatus,
    date,
  }) => {
    try {
      const { url, method, headers } = api.getOrdersByAgentCode(
        agentCode,
        currentPage,
        pageSize,
        q,
        orderStatus,
        typeStatus,
        date
      );

      const orders = await axios({
        url,
        method,
        headers,
      });
      return orders.data;
    } catch (error) {
      return error.message;
    }
  }
);

export const getOrderById = createAsyncThunk(
  "ordersSlice/getOrderById",
  async (id) => {
    try {
      const { url, method, headers } = api.getOrderById(id);
      const order = await axios({
        url,
        method,
        headers,
      });
      return order.data;
    } catch (error) {
      return error.message;
    }
  }
);

export const getEditingOrderById = createAsyncThunk(
  "ordersSlice/getEditingOrderById",
  async (id) => {
    try {
      const { url, method, headers } = api.getOrderById(id);
      const order = await axios({
        url,
        method,
        headers,
      });
      return order.data;
    } catch (error) {
      return error.message;
    }
  }
);

export const getOrderYears = createAsyncThunk(
  "ordersSlice/getOrderYears",
  async () => {
    try {
      const { url, method, headers } = api.getOrderYears();
      const order = await axios({
        url,
        method,
        headers,
      });
      return order.data;
    } catch (error) {
      return error.message;
    }
  }
);

export const createNewOrder = createAsyncThunk(
  "ordersSlice/createNewOrder",
  async ({ order }, { rejectWithValue }) => {
    try {
      const { url, method, headers, data } = api.createNewOrder(order);
      const newOrder = await axios({
        url,
        method,
        headers,
        data,
      });
      return newOrder.data;
    } catch (error) {
      // Gestione corretta degli errori HTTP
      if (error.response) {
        // Errore dal server (4xx, 5xx)
        return rejectWithValue({
          status: error.response.status,
          message: error.response.data?.message || "Errore del server",
          data: error.response.data,
        });
      } else if (error.request) {
        // Errore di rete
        return rejectWithValue({
          message: "Errore di connessione",
        });
      } else {
        // Altri errori
        return rejectWithValue({
          message: error.message,
        });
      }
    }
  }
);

export const updateOrderById = createAsyncThunk(
  "ordersSlice/updateOrderById",
  async ({ updateData }) => {
    try {
      const { url, method, headers, data } = api.updateOrderById(updateData);
      const order = await axios({
        url,
        method,
        headers,
        data,
      });
      return order.data;
    } catch (error) {
      return error.message;
    }
  }
);
export const duplicateOrderById = createAsyncThunk(
  "ordersSlice/duplicateOrderById",
  async (id) => {
    try {
      const { url, method, headers } = api.duplicateOrderById(id);
      const order = await axios({
        url,
        method,
        headers,
      });
      return order.data;
    } catch (error) {
      return error.message;
    }
  }
);
export const deleteOrderById = createAsyncThunk(
  "ordersSlice/deleteOrderById",
  async (id) => {
    try {
      const { url, method, headers } = api.deleteOrderById(id);
      const order = await axios({
        url,
        method,
        headers,
      });
      return order.data;
    } catch (error) {
      return error.message;
    }
  }
);

export const { resetOrderCreated, resetEditingOrder } = ordersSlice.actions;
export const { actions } = ordersSlice;
export default ordersSlice.reducer;
